import { fetchConfig } from '@theme/utilities';
import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

if (!window.frequentlyBoughtTogetherInitialized) {
  window.frequentlyBoughtTogetherInitialized = true;

  document.addEventListener('click', async (event) => {
    const target = event.target;
    const button = target instanceof Element ? target.closest('[data-frequently-bought-add]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const variantIds = (button.dataset.variantIds || '').split(',').filter(Boolean);
    if (!variantIds.length) return;

    const status = button.parentElement?.querySelector('[data-frequently-bought-status]');
    const originalLabel = button.textContent;
    const sections = Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
      .filter(Boolean)
      .join(',');
    const deferred = CartLinesUpdateEvent.createPromise();

    button.disabled = true;
    button.textContent = 'Adding...';

    button.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: variantIds.map((id) => ({ merchandiseId: id, quantity: 1 })),
      promise: deferred.promise,
    }));

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: variantIds.map((id) => ({ id: Number(id), quantity: 1 })),
          sections,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Add to cart failed');

      const cartResponse = await fetch(`${Theme.routes.cart_url}.json`, fetchConfig('json'));
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'frequently-bought-together',
          itemCount: variantIds.length,
          sections: result.sections,
          didError: false,
        },
      });

      button.textContent = 'Added';
      if (status) status.textContent = `${variantIds.length} products added to your bag.`;
      window.Shopify?.actions?.openCart();
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Add to cart failed';
      button.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
      deferred.reject(error);
      if (status) status.textContent = message;
      button.textContent = originalLabel;
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalLabel;
      }, 1200);
    }
  });
}
